import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import SimpleModal from '../Modal';

const useStyles = makeStyles(() => ({
  hbsptForm: {
    margin: 20,
  },
}));

const loadHubSpot = callback => {
  if (typeof window === 'undefined') return;
  const existingScript = document.getElementById('HBSPT_FORMS_LIB');

  // Supress hubspot form warning over missing jquery for onFormLoad
  (function() {
    window.jQuery =
      window.jQuery ||
      function(nodeOrSelector) {
        if (typeof nodeOrSelector === 'string') {
          return document.querySelector(s);
        }
        return nodeOrSelector;
      };
  })();

  if (!existingScript) {
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/v2.js';
    script.id = 'HBSPT_FORMS_LIB';
    document.body.appendChild(script);

    script.onload = () => {
      window.hbspt_loaded = true;
      if (callback) callback();
    };
  }

  if (existingScript && callback && window.hbspt_loaded) callback();
};

const HubspotFormsModal = ({ portalId, formId, isOpen, onClose, onFormReady, onFormSubmitted }) => {
  const classes = useStyles();
  const [isHubspotFormCreating, setHubspotFormCreating] = useState(false);
  const formContainer = useRef(null);

  useEffect(() => loadHubSpot(initForm), []);

  const initForm = () => {
    if (isHubspotFormCreating) return;
    if (typeof window === 'undefined' || !window.hbspt_loaded) return;
    if (formContainer.current) formContainer.current.innerHTML = '';
    setHubspotFormCreating(true);
    hbspt.forms.create({
      portalId,
      formId,
      onFormReady(form, ctx) {
        onFormReady(form, ctx);
        setHubspotFormCreating(false);
      },
      cssClass: classes.hbsptForm,
      target: `#hbspt_form_${formId}`,
      onFormSubmitted,
    });
  };

  const onModalClose = () => {
    onClose();
    initForm();
  };

  return (
    <SimpleModal hideCloseIcon keepMounted onClose={onModalClose} isModalOpen={isOpen} className={classes.modal}>
      <div ref={formContainer} id={`hbspt_form_${formId}`} className={classes.hbsptForm}></div>
    </SimpleModal>
  );
};

HubspotFormsModal.propTypes = {
  portalId: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onFormReady: PropTypes.func,
  onFormSubmitted: PropTypes.func,
};

export default HubspotFormsModal;
